import { apiConnector } from './apiconnector';

const API_BASE = process.env.REACT_APP_API_URL;

export const plantAPI = {
  // Get all plants
  getAllPlants: async () => {
    try {
      const response = await apiConnector('GET', `${API_BASE}/plants`);
      return response.data;
    } catch (error) {
      console.error('Get plants error:', error);
      throw error;
    }
  },

  // Create new plant
  createPlant: async (plantData) => {
    try {
      const response = await apiConnector('POST', `${API_BASE}/plants`, plantData);
      return response.data;
    } catch (error) {
      console.error('Create plant error:', error);
      throw error;
    }
  },

  // Update plant
  updatePlant: async (plantId, plantData) => {
    try {
      const response = await apiConnector('PUT', `${API_BASE}/plants/${plantId}`, plantData);
      return response.data;
    } catch (error) {
      console.error('Update plant error:', error);
      throw error;
    }
  },

  // Delete plant
  deletePlant: async (plantId) => {
    try {
      const response = await apiConnector('DELETE', `${API_BASE}/plants/${plantId}`);
      return response.data;
    } catch (error) {
      console.error('Delete plant error:', error);
      throw error;
    }
  },

  // Assign admin to plant
  assignAdmin: async (plantId, adminId) => {
    try {
      const response = await apiConnector('PUT', `${API_BASE}/plants/${plantId}/assign-admin`, { adminId });
      return response.data;
    } catch (error) {
      console.error('Assign admin error:', error);
      throw error;
    }
  },

  // Get plant analytics
  getPlantAnalytics: async (plantId) => {
    try {
      const endpoint = plantId ? `${API_BASE}/plants/${plantId}/analytics` : `${API_BASE}/plants/analytics`;
      const response = await apiConnector('GET', endpoint);
      return response.data;
    } catch (error) {
      console.error('Get plant analytics error:', error);
      throw error;
    }
  }
};